import { useEffect, useState } from "react";
import "./LiveAuctions.css";
import { formatDollarPrice } from "../../utils/Price";

const { REACT_APP_IMAGE_URL } = process.env;

export const imgUrl = (src) => (String(src).startsWith("http") ? src : `${REACT_APP_IMAGE_URL}${src}`);

export const formatDate = (v) =>
  v
    ? new Date(v).toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : "-";

export const money = (v) =>
  v === null || v === undefined || v === "" ? "-" : formatDollarPrice(v);

export const pick = (obj, ...keys) => {
  for (const k of keys) {
    const v = k.split(".").reduce((o, p) => o?.[p], obj);
    if (v !== undefined && v !== null && v !== "") return v;
  }
  return undefined;
};

// stagger index for the .la-reveal entrance animation
export const reveal = (i = 0) => ({ "--i": Math.min(i, 12) });

export const StatusBadge = ({ status }) => {
  const s = String(status || "").toLowerCase();
  const cls = ["live", "active", "pending", "closed", "won", "outbid"].includes(s) ? s : "default";
  return <span className={`la-badge ${cls}`}>{status || "-"}</span>;
};

export const Thumb = ({ src }) =>
  src ? (
    <img className="la-thumb" alt="" src={imgUrl(src)} />
  ) : (
    <div className="la-thumb la-thumb-empty">
      <i className="bi bi-image"></i>
    </div>
  );

export const FilterTabs = ({ options, value, onChange }) => (
  <div className="la-tabs">
    {options.map((o) => (
      <button
        key={o.label}
        className={`la-tab ${value === o.value ? "active" : ""}`}
        onClick={() => onChange(o.value)}
      >
        {o.label}
      </button>
    ))}
  </div>
);

const useNow = (enabled) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!enabled) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [enabled]);
  return now;
};

export const timeLeft = (end, now = Date.now()) => {
  const ms = new Date(end).getTime() - now;
  if (!end || isNaN(ms)) return null;
  if (ms <= 0) return { ended: true, text: "Ended", ms: 0 };
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const text = d > 0 ? `${d}d ${h}h ${m}m` : h > 0 ? `${h}h ${m}m ${sec}s` : `${m}m ${sec}s`;
  return { ended: false, text, ms };
};

// ticking countdown; renders "Ended" once past
export const Countdown = ({ end, className = "" }) => {
  const tl = timeLeft(end);
  const now = useNow(!!tl && !tl.ended);
  const cur = timeLeft(end, now);
  if (!cur) return <span className={className}>-</span>;
  return (
    <span className={`la-countdown ${cur.ms > 0 && cur.ms < 3600000 ? "urgent" : ""} ${className}`}>
      {cur.text}
    </span>
  );
};

export const CardSkeletons = ({ count = 8 }) =>
  Array.from({ length: count }).map((_, i) => (
    <div key={i} className="la-skel-card">
      <div className="s-media" />
      <div className="s-body">
        <div className="s-line" style={{ width: "70%" }} />
        <div className="s-line" style={{ width: "40%" }} />
        <div className="s-line" style={{ width: "90%" }} />
      </div>
    </div>
  ));

export const EmptyState = ({ text = "No records found" }) => (
  <div className="la-card la-empty">
    <i className="bi bi-inbox"></i>
    {text}
  </div>
);

export const SkeletonRows = ({ cols, rows = 8 }) =>
  Array.from({ length: rows }).map((_, r) => (
    <tr key={r}>
      {Array.from({ length: cols }).map((__, c) => (
        <td key={c}>
          <div className="s-line" />
        </td>
      ))}
    </tr>
  ));

export const EmptyRow = ({ cols }) => (
  <tr>
    <td colSpan={cols}>
      <div className="la-empty">
        <i className="bi bi-inbox"></i>No records found
      </div>
    </td>
  </tr>
);
